var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    fontSize: "24px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.45 18.62 19.5 24l-8.05 5.38A10 10 0 0 0 7 37.69V45a1 1 0 0 0 1 1h32a1 1 0 0 0 1-1v-7.3a10 10 0 0 0-4.45-8.32L28.5 24l8.05-5.38A10 10 0 0 0 41 10.31V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7.3a10 10 0 0 0 4.45 8.32ZM37 6v4.3a6 6 0 0 1-2.67 5L28.78 19h-9.56l-5.55-3.7a6 6 0 0 1-2.67-5V6h26Zm0 36H11v-4h26v4Zm-24.73-8a6 6 0 0 1 1.4-1.3L24 25.8l10.33 6.9a6 6 0 0 1 1.4 1.3H12.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.d1cc9d86c692a56ff7813bb5e90accb1.svg";
export { ForwardRef as ReactComponent };